import { DateTime } from "luxon";

interface businessDocumentVM {
  businessDocumentType: number;
  businessDocumentName: string;
  documentNumber: string;
  salesDate: string;
  issueDate: string;
  salesDateAsDateOnly?: Date;
  issueDateAsDateOnly?: Date;
}

/** Fills native date fields in the object */
export function correctBusinessDocumentVmDates(item: businessDocumentVM) {
  item.salesDateAsDateOnly = DateTime.fromISO(item.salesDate)
    .startOf("day")
    .toJSDate();
  item.issueDateAsDateOnly = DateTime.fromISO(item.issueDate)
    .startOf("day")
    .toJSDate();
}

export default businessDocumentVM;
